import type { EntityOption } from '@/components/shared/entity-combobox';

interface MinisterPickerRow {
  memberId: string;
  memberName: string;
  title: string;
  role: string;
  isActive: boolean;
}

interface MemberPickerRow {
  id: string;
  firstName: string;
  lastName: string;
}

const matchesQuery = (needle: string, ...parts: string[]) => {
  if (!needle) return true;
  const haystack = parts.join(' ').toLowerCase();
  return haystack.includes(needle);
};

/** Ministers first, then other members — deduped by member id. */
export const buildWorshipMemberOptions = (
  ministers: MinisterPickerRow[],
  members: MemberPickerRow[],
  query: string,
): EntityOption[] => {
  const needle = query.trim().toLowerCase();

  const ministerOptions = ministers
    .filter((row) => row.isActive)
    .filter((row) => matchesQuery(needle, row.title, row.memberName, row.role))
    .map((row) => ({
      id: row.memberId,
      label: `${row.title} ${row.memberName}`.trim(),
      description: row.role,
    }));

  const ministerMemberIds = new Set(ministerOptions.map((row) => row.id));

  const memberOptions = members
    .filter((member) => !ministerMemberIds.has(member.id))
    .filter((member) => matchesQuery(needle, member.firstName, member.lastName))
    .map((member) => ({
      id: member.id,
      label: `${member.firstName} ${member.lastName}`.trim(),
    }));

  return [...ministerOptions, ...memberOptions];
};
